var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModelZFeature5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.022 12.7001C30.022 18.8661 24.01 23.8661 24.01 23.8661C24.01 23.8661 18 18.8661 18 12.7001C18 6.53412 24.01 1.53212 24.01 1.53212C24.01 1.53212 30.022 6.53212 30.022 12.7001Z",
    stroke: "#D0C7A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3746 40.3999C34.1586 46.6259 24.0006 46.5319 24.0006 46.5319C24.0006 46.5319 23.9066 36.3639 30.1226 30.1479C36.3386 23.9319 46.5066 24.0279 46.5066 24.0279C46.5066 24.0279 46.5886 34.1999 40.3746 40.3999Z",
    stroke: "#D0C7A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61667 40.3999C13.8327 46.6259 24.0007 46.5319 24.0007 46.5319C24.0007 46.5319 24.0947 36.3639 17.8787 30.1479C11.6627 23.9319 1.49667 24.0279 1.49667 24.0279C1.49667 24.0279 1.40067 34.1999 7.61667 40.3999Z",
    stroke: "#D0C7A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0122 23.866V46.532",
    stroke: "#D0C7A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgModelZFeature5;